import { Grid, Image } from "antd";
import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { BannerResponse } from "../../../../hooks/data";
import "./style";
import styles from "./styleModule";

const PromotionBannerContainer: React.FC<{
  banners: BannerResponse[];
  loadingBanner: boolean;
  visibleBanner: BannerResponse[];
  autoplayDelay: number;
  handleOpenUrl: (url: string | null | undefined) => void;
  renderLoading: () => React.ReactNode;
}> = ({
  banners,
  loadingBanner,
  visibleBanner,
  autoplayDelay,
  handleOpenUrl,
  renderLoading,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getMarginTop = () => {
    if (screens.xxl) return "28px";
    if (screens.xl) return "28px";
    if (screens.lg) return "28px";
    if (screens.md) return "28px";
    if (screens.sm) return "-83px";
    return "-106px"; // Default for xs or smaller
  };

  const getBannerSize = () => {
    if (screens.xxl) return { width: 616, height: 264 };
    if (screens.xl) return { width: 616, height: 264 };
    if (screens.lg) return { width: 616, height: 264 };
    if (screens.md) return { width: 616, height: 264 };
    if (screens.sm) return { width: 397, height: 170 };
    return { width: 333, height: 143 }; // Default for xs or smaller
  };
  return (
    <div
      className={`${styles.bannerContainer} promo-banner`}
      style={{ marginTop: getMarginTop() }}
    >
      {!banners || loadingBanner ? (
        renderLoading()
      ) : (
        <Swiper
          pagination={
            screens.xs ? { dynamicBullets: true, clickable: true } : undefined
          }
          modules={[Autoplay, Pagination]}
          slidesPerView={"auto"}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
          spaceBetween={28}
          slideToClickedSlide={true}
          style={{ padding: 0 }}
        >
          {visibleBanner.map((banner: BannerResponse, index: number) => {
            return (
              <SwiperSlide
                key={`banner_${index}`}
                style={{ ...getBannerSize() }}
              >
                <Image
                  onClick={() => handleOpenUrl(banner?.link_url)}
                  width={"100%"}
                  height={"100%"}
                  preview={false}
                  src={banner.image_url}
                  className={styles.bannerImage}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default PromotionBannerContainer;
